export const downloadTenantShipmentsCsvEndpoint = (tenantId: number): string =>
  `/tenants/${tenantId}/shipments/csv/download`
